<template>
  <div id="app">
    <auth-loading>
      <router-view></router-view>
    </auth-loading>
  </div>
</template>

<script>
import AuthLoading from '@/components/common/AuthLoading.vue';

export default {
  components: {
    AuthLoading,
  },
};
</script>

<style src="./assets/styles/reset.css"></style>
<style lang="scss" src="./assets/styles/common.scss"></style>
<style lang="scss" scoped>
#app {
  height: 100vh;
  width: 100%;
  display: flex;
  font-family: 'Roboto Regular', sans-serif;
}
</style>
